import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeStatus } from "../Redux/features/Filter/actions";

const Filter = () => {
 const filter = useSelector((state) => state.filter);
 const dispatch = useDispatch();
 const changeFilter = (status) => {
  dispatch(changeStatus(status));
 };

 return (
  <div>
   <div className="flex items-center justify-between mb-12">
    <h4 className="mt-2 text-xl font-bold">Book List</h4>

    <div className="flex items-center space-x-4">
     <button
      className={`filter-btn ${filter.status == "All" && "active-filter"}`}
      id="lws-filterAll"
      onClick={() => changeFilter("All")}
     >
      All
     </button>
     <button
      className={`filter-btn ${filter.status == "Featured" && "active-filter"}`}
      id="lws-filterFeatured"
      onClick={() => changeFilter("Featured")}
     >
      Featured
     </button>
    </div>
   </div>
  </div>
 );
};

export default Filter;
